import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleSelectFormInput, { SimpleSelectFormInputProps } from './SimpleSelectFormInput';
import { useContrySelect } from '../../hooks';
import { useFlexSalesForm } from './FlexSalesForm';
import { Country } from '../../types';

export type CountrySelectFormInputProps = Omit<SimpleSelectFormInputProps, 'options' | 'value'> & {
  propId?: keyof Country;
  allowedCountryCodes?: string[];
};

const CountrySelectFormInput = ({
  name,
  propId,
  disabled,
  allowedCountryCodes,
  ...rest
}: CountrySelectFormInputProps) => {
  const { t } = useTranslation();
  const { options, loading, disabled: disabledProp } = useContrySelect(allowedCountryCodes);
  const { setValue } = useFlexSalesForm();
  const isDisabled = disabled || disabledProp;
  const singleCountryId = options.length === 1 ? options[0].id : undefined;
  useEffect(() => {
    if (singleCountryId !== undefined) setValue(name, singleCountryId);
  }, [setValue, name, singleCountryId]);

  return (
    <SimpleSelectFormInput
      {...rest}
      name={name}
      label={t('toolbar.labels.country')}
      options={options}
      disabled={isDisabled}
      loading={loading}
    />
  );
};

export default CountrySelectFormInput;
